import type { Selection } from "../types";

export function selectionEntityId(selection: Selection): string | null {
  switch (selection.kind) {
    case 'email':
      return null;
    case 'group':
      return `group:${selection.groupId}`;
    case 'row':
      return `row:${selection.rowId}`;
    case 'column':
      return `column:${selection.rowId}:${selection.columnId}`;
    case 'block':
      return `block:${selection.blockId}`;
    case 'buttonRowSlot':
      return `button-row-slot:${selection.blockId}:${selection.slotIndex}`;
  }
}
